import React, { useEffect, useState } from 'react'
import AOS from 'aos'
import PAGE_CONSTANT_TEXTS from 'constants/pageMetaTags'
import PageWrapper from 'components/PageWrapper'

import { Accordion } from 'react-bootstrap'
import Slider from 'react-slick'
import CountUp from 'react-countup'
import VisibilitySensor from 'react-visibility-sensor'

import ContactUsAzureModel from 'components/ContactUsAzureModel'
import { CDN_URL } from 'services/config'
import Image from 'next/image'
import BreadcrumbList from 'components/StructuredData'
import { useRouter } from 'next/router'
import { FAQConstant } from 'constants/FAQConstant'
import Button from 'components/Button'

const csSettings = {
  dots: false,
  infinite: true,
  speed: 300,
  slidesToShow: 4,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 991,
      settings: {
        slidesToShow: 3,
      },
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
      },
    },
  ],
}
const benefitSettings = {
  dots: false,
  infinite: true,
  arrows: false,
  speed: 700,
  autoplay: true,
  autoplaySpeed: 3000,
  slidesToShow: 3,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 1199,
      settings: {
        slidesToShow: 2,
      },
    },
    {
      breakpoint: 991,
      settings: {
        slidesToShow: 2,
      },
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
      },
    },
  ],
}

export async function getStaticProps() {
  return { props: { isErrorCls: true } }
}
const HireAspDotnetMvcDevelopers = () => {
  const [showContact, setShowContact] = useState(false)
  const handleShowContact = () => setShowContact(true)
  const handleCloseContact = () => setShowContact(false)

  const router: any = useRouter()
  const faqJsonData =
    FAQConstant[
      router.query.path ? router.query.path : router.pathname.split('/')[1]
    ]

  const schemaDataFAQ = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqJsonData.map(({ title, description }) => ({
      '@type': 'Question',
      name: title,
      acceptedAnswer: {
        '@type': 'Answer',
        text: description,
      },
    })),
  }

  useEffect(() => {
    AOS.init()
  }, [])

  return (
    <PageWrapper {...PAGE_CONSTANT_TEXTS.AspDotnetMvc}>
      <BreadcrumbList nameH1="Microsoft Asp.net" />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(schemaDataFAQ) }}
      />
      <main className="">
        <section className="head_bg pt-120px pb-100px mb-100px">
          <div className="container">
            <div className="technology_sec mt-4">
              <div className="row align-items-center">
                <div className="col-lg-6">
                  <div className="tech_content mb-4 mb-lg-0">
                    <h1 className="title64px700 head_color">
                      Microsoft ASP.Net MVC Development Services
                    </h1>
                    <p className="fw-400 fs-16px">
                      WebClues offers creative and innovative ASP.Net MVC
                      development services meant to help budding and established
                      companies leverage the best of everything this technology
                      has to offer. MVC adheres to the model view controller
                      paradigm in its entirety, allowing developers to design
                      websites and web applications in modules for bug-free
                      results.
                    </p>
                    <Button onClick={handleShowContact}>
                      Hire ASP.NET MVC Developers
                    </Button>
                  </div>
                </div>
                <div className="col-lg-6">
                  <div className="tech_img d-flex">
                    <div className="w-37 pe-3">
                      <Image
                        src="/assets/images/solutions/dotnet-mvc-img/mvcimg1.jpg"
                        alt="development"
                        className="img-fluid"
                        quality={70}
                        height={550}
                        width={265}
                      />
                    </div>
                    <div className="w-21 pe-3">
                      <Image
                        src="/assets/images/solutions/dotnet-mvc-img/mvcimg2.jpg"
                        alt="development"
                        className="img-fluid"
                        quality={70}
                        height={550}
                        width={140}
                      />
                    </div>
                    <div className="w-21">
                      <Image
                        src="/assets/images/solutions/dotnet-mvc-img/mvcimg3.jpg"
                        alt="development"
                        className="img-fluid"
                        quality={70}
                        height={550}
                        width={140}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <div className="container">
          <div className="client_slides pb-100px">
            {/* <div> */}
            <div className="logoSlider">
              <Slider {...csSettings}>
                <div className="client_logo">
                  <Image
                    src="/assets/images/solutions/dotnet-mvc-img/clientlogo/01.png"
                    alt="development"
                    className="img-fluid"
                    quality={70}
                    height={75}
                    width={150}
                  />
                </div>
                <div className="client_logo">
                  <Image
                    src="/assets/images/solutions/dotnet-mvc-img/clientlogo/02.png"
                    alt="development"
                    className="img-fluid"
                    quality={70}
                    height={75}
                    width={150}
                  />
                </div>
                <div className="client_logo">
                  <Image
                    src="/assets/images/solutions/dotnet-mvc-img/clientlogo/03.png"
                    alt="development"
                    className="img-fluid"
                    quality={70}
                    height={75}
                    width={150}
                  />
                </div>
                <div className="client_logo">
                  <Image
                    src="/assets/images/solutions/dotnet-mvc-img/clientlogo/04.png"
                    alt="development"
                    className="img-fluid"
                    quality={70}
                    height={75}
                    width={150}
                  />
                </div>
                <div className="client_logo">
                  <Image
                    src="/assets/images/solutions/dotnet-mvc-img/clientlogo/05.png"
                    alt="development"
                    className="img-fluid"
                    quality={70}
                    height={75}
                    width={150}
                  />
                </div>
              </Slider>
            </div>
          </div>
          <div className="tech_devlopment pb-100px">
            <div className="row">
              <div className="col-lg-8">
                <div className="title36px700 head_color titleBorder">
                  Understanding ASP.Net MVC Development
                </div>
                <div className="my-4">
                  The Model-View-Controller (MVC) architectural pattern divides
                  an application into three logical components: model, view, and
                  controller. Each of these components handles a specific part
                  of the development exercise. MVC pattern has become an
                  industry standard for development, creating scalable and
                  flexible solutions. As a leading ASP.Net MVC development
                  company, we leverage this combination to build powerful,
                  robust, dynamic, and pattern-based applications. It allows us
                  to initiate a clean separation of patterns.{' '}
                </div>
                <div className="row">
                  <div className="col-md-4 mb-3">
                    <div className="box_tech_dev h-100">
                      <h3>Model</h3>
                      <div>
                        Model is the state of the application and incorporates
                        the business logic and operational side of the solution.
                      </div>
                    </div>
                  </div>
                  <div className="col-md-4 mb-3">
                    <div className="box_tech_dev h-100">
                      <h3>View</h3>
                      <div>
                        View is about presenting the information via user
                        interface. It has minimal logic and is executed through
                        HTML markup.
                      </div>
                    </div>
                  </div>
                  <div className="col-md-4 mb-3">
                    <div className="box_tech_dev h-100">
                      <h3>Controller</h3>
                      <div>
                        Controllers are tasked with handling the user
                        interaction. It works with model and view components for
                        better user interaction.
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-4">
                <Image
                  src="/assets/images/solutions/dotnet-mvc-img/devs_img.jpg"
                  alt="development"
                  className="img-fluid"
                  quality={70}
                  height={238}
                  width={296}
                />
              </div>
            </div>
          </div>
          <div className="dev_service pb-100px">
            <div className="title36px700 head_color text-center titleBorder left50 mb-xl-5 mb-3">
              Services WebClues Offers in ASP.Net MVC Development
            </div>
            <div className="row">
              <div className="col-lg-6 mb-3">
                <div className="box_tech_dev light_blue ">
                  <h3>ASP.NET MVC Web App Development</h3>
                  <div>
                    We help you build interactive and high-performance web
                    applications based on the MVC pattern. Our solutions are
                    efficient, scalable, and cater to business needs. We also
                    leverage an efficient suite of tools and technologies
                    combined with ASP.Net for the best results for web app
                    development.
                  </div>
                </div>
              </div>
              <div className="col-lg-3 col-md-6 mb-3">
                <div className="box_tech_dev light_cream ">
                  <h3>ASP.NET WEB API Development</h3>
                  <div>
                    Our Web API solutions will let your customers and clients
                    access a broad spectrum of services built specifically for
                    every type of device and platform.
                  </div>
                </div>
              </div>
              <div className="col-lg-3 col-md-6 mb-3">
                <div className="box_tech_dev light_green ">
                  <h3>ASP.NET MVC 3rd Party Integration</h3>
                  <div>
                    Driven with development expertise, our ASP.Net MVC
                    development services will also take care of integrating your
                    existing solutions with 3rd party platforms for wider
                    performance and better functionality.
                  </div>
                </div>
              </div>
              <div className="col-lg-3 col-md-6 mb-3">
                <div className="box_tech_dev light_color1 ">
                  <h3>ASP.NET MVC Migration Services</h3>
                  <div>
                    The ASP.Net MVC framework is more secure, stable, and
                    efficient. We can help you migrate to this setting to manage
                    complex business functionality with ease.
                  </div>
                </div>
              </div>
              <div className="col-lg-3 col-md-6 mb-3">
                <div className="box_tech_dev light_color2 ">
                  <h3>ASP.NET MVC Consultation Services</h3>
                  <div>
                    When in doubt, ask our MVC and ASP.Net experts to give you
                    the best solution possible regarding your existing position
                    and requirements.
                  </div>
                </div>
              </div>

              <div className="col-lg-6 mb-3">
                <div className="box_tech_dev light_color4 ">
                  <h3>ASP.NET MVC Maintenance & Support</h3>
                  <div>
                    Our post-development service teams efficiently handle all
                    sorts of support and troubleshooting requirements. For
                    adding more features to your existing application, ask us
                    for a special quote.
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="dev_partner mb-100px">
          <div className="dev_pernter_bg">
            <div className="single_wave_img" />
          </div>
          <div className="container">
            <div className="dev_pernter_content">
              <div className="align-items-center row">
                <div className="col-lg-6">
                  <div className="">
                    <h2 className="title36px700 titleBorder text-white">
                      Why is WebClues your Ideal ASP.Net MVC Development
                      Company?
                    </h2>
                    <div className="my-4 text">
                      WebClues developers are adamant and highly motivated to
                      bring the best of ASP.Net and MVC architecture to your
                      business. Our expertise in the domain makes us the
                      stepping stone you need to climb up the ladder in a
                      competitive market. Our codes are clean, readable, and
                      scalable.
                    </div>
                    <div className="mb-4 text">
                      Working with WebClues means you will get the work on time
                      and of top-notch quality. We have worked with several
                      companies in the past and have delivered a wide range of
                      projects successfully.
                    </div>
                  </div>
                </div>
                <div className="col-lg-6 expertice_number ps-xl-5">
                  <div className="expertice_number">
                    <div className="rounded-20 expert_bg">
                      <CountUp start={1} end={180} duration={0.9}>
                        {({ countUpRef, start }) => (
                          <VisibilitySensor onChange={start}>
                            <span
                              className="fs-xxl-28px fs-xl-24px fs-20px fw-600 text-white counter"
                              ref={countUpRef}
                            />
                          </VisibilitySensor>
                        )}
                      </CountUp>
                      <span className="fs-xxl-28px fs-xl-24px fs-20px fw-600 text-white counter">
                        +
                      </span>
                      <div className="text pt-2">Industry Experts</div>
                    </div>
                  </div>
                  <div className="expertice_number d-flex justify-content-end expertice_number_margin">
                    <div className="rounded-20 expert_bg">
                      <CountUp start={1} end={800} duration={0.9}>
                        {({ countUpRef, start }) => (
                          <VisibilitySensor onChange={start}>
                            <span
                              className="fs-xxl-28px fs-xl-24px fs-20px fw-600 text-white counter"
                              ref={countUpRef}
                            />
                          </VisibilitySensor>
                        )}
                      </CountUp>
                      <span className="fs-xxl-28px fs-xl-24px fs-20px fw-600 text-white counter">
                        +
                      </span>
                      <div className="text pt-2">Projects Completed</div>
                    </div>
                  </div>
                  <div className="expertice_number expertice_number_margin">
                    <div className="rounded-20 expert_bg">
                      <CountUp start={1} end={260} duration={0.9}>
                        {({ countUpRef, start }) => (
                          <VisibilitySensor onChange={start}>
                            <span
                              className="fs-xxl-28px fs-xl-24px fs-20px fw-600 text-white counter"
                              ref={countUpRef}
                            />
                          </VisibilitySensor>
                        )}
                      </CountUp>
                      <span className="fs-xxl-28px fs-xl-24px fs-20px fw-600 text-white counter">
                        +
                      </span>
                      <div className="text pt-2">Fortune Clients</div>
                    </div>
                  </div>
                  <div className="expertice_number d-flex justify-content-end">
                    <div className="rounded-20 expert_bg">
                      <CountUp start={1} end={6} duration={0.9}>
                        {({ countUpRef, start }) => (
                          <VisibilitySensor onChange={start}>
                            <span
                              className="fs-xxl-28px fs-xl-24px fs-20px fw-600 text-white counter"
                              ref={countUpRef}
                            />
                          </VisibilitySensor>
                        )}
                      </CountUp>

                      <div className="text pt-2">Offices</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="benifits_mvc_sectionMain pb-100px">
          <div className="container">
            <div className="benifite_mvc_section rounded-20">
              <div className="row">
                <div className="col-lg-4 col-md-6">
                  <div className="benifite_mvc_content box_tech_dev rounded-20">
                    <div className="title36px700 head_color titleBorder">
                      Why Should You Choose ASP.Net MVC?
                    </div>
                    <div className="my-3">
                      The ASP.NET MVC framework is a lightweight, controllable,
                      and easy to test architecture framework that offers
                      distinct separation of concerns for UI, business logic,
                      and data to explicitly design efficient applications for
                      your enterprise. Our ASP.Net MVC development services
                      pattern is based on a unique framework for creating
                      dynamic web applications and websites with a clear
                      separation of concerns. With this technology, a developer
                      will enjoy complete markup control TDD-friendly
                      development while adhering to the latest web standards.
                    </div>
                    <Button className="zIndex1" onClick={handleShowContact}>
                      Contact us
                    </Button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="container-fluid">
            <div className="benfits_slides">
              <div className="row justify-content-end">
                <div className="col-lg-7 col-md-6">
                  <div className="whySlider">
                    <Slider {...benefitSettings}>
                      <div>
                        <div className="benifits_blocks_white">
                          <Image
                            src="/assets/images/solutions/dotnet-mvc-img/b1.svg"
                            alt="development"
                            className="img-fluid"
                            quality={70}
                            height={48}
                            width={48}
                          />
                          <div className="head_color fs-xxl-24px fs-xl-20px fs-18px fw-600">
                            Powerful Routing
                          </div>
                          <div>
                            The ASP.Net MVC pattern is built on top of a
                            powerful routing system that helps build robust
                            mapping components for easy searching functions.
                          </div>
                        </div>
                      </div>
                      <div>
                        <div className="benifits_blocks_white">
                          <Image
                            src="/assets/images/solutions/dotnet-mvc-img/b2.svg"
                            alt="development"
                            className="img-fluid"
                            quality={70}
                            height={48}
                            width={48}
                          />
                          <div className="head_color fs-xxl-24px fs-xl-20px fs-18px fw-600">
                            Dependency Injection
                          </div>
                          <div>
                            ASP.Net MVC framework has an in-built dependency
                            injection feature allowing the developers to create
                            a system for calling the needed services through
                            constructors to reduce class coupling and increase
                            code reusing.
                          </div>
                        </div>
                      </div>
                      <div>
                        <div className="benifits_blocks_white">
                          <Image
                            src="/assets/images/solutions/dotnet-mvc-img/b3.svg"
                            alt="development"
                            className="img-fluid"
                            quality={70}
                            height={48}
                            width={48}
                          />
                          <div className="head_color fs-xxl-24px fs-xl-20px fs-18px fw-600">
                            Web APIs
                          </div>
                          <div>
                            When you hire ASP.Net MVC developers from WebClues,
                            they will build bespoke web APIs to enhance the
                            scope of services to reach a wider audience.
                          </div>
                        </div>
                      </div>
                      <div>
                        <div className="benifits_blocks_white">
                          <Image
                            src="/assets/images/solutions/dotnet-mvc-img/b4.svg"
                            alt="development"
                            className="img-fluid"
                            quality={70}
                            height={48}
                            width={48}
                          />
                          <div className="head_color fs-xxl-24px fs-xl-20px fs-18px fw-600">
                            Test-Driven Development
                          </div>
                          <div>
                            TDD is a development approach where testing goes
                            simultaneously with application development. The
                            ASP.Net MVC is enabled with TDD that helps the
                            developers plug the bugs and loopholes during
                            development.
                          </div>
                        </div>
                      </div>
                      <div>
                        <div className="benifits_blocks_white">
                          <Image
                            src="/assets/images/solutions/dotnet-mvc-img/b5.svg"
                            alt="development"
                            className="img-fluid"
                            quality={70}
                            height={48}
                            width={48}
                          />
                          <div className="head_color fs-xxl-24px fs-xl-20px fs-18px fw-600">
                            Filters in MVC
                          </div>
                          <div>
                            Adding filters in the development process can help
                            with authorization and effective handling of the
                            tasks. Developers benefit from this by running pre
                            and post processing logic leading to actionable
                            methods.
                          </div>
                        </div>
                      </div>
                      <div>
                        <div className="benifits_blocks_white">
                          <Image
                            src="/assets/images/solutions/dotnet-mvc-img/b6.svg"
                            alt="development"
                            className="img-fluid"
                            quality={70}
                            height={48}
                            width={48}
                          />
                          <div className="head_color fs-xxl-24px fs-xl-20px fs-18px fw-600">
                            Cloud Development Support
                          </div>
                          <div>
                            Building applications with the modern MVC
                            architecture on the Microsoft ASP.Net technology
                            makes it easier to deploy the solutions on the
                            cloud.
                          </div>
                        </div>
                      </div>
                    </Slider>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="container mb-100px">
          <div className="secDevTool" id="secDevTool">
            <div className="title36px700 head_color text-center titleBorder left50">
              Tools We Use with ASP.Net MVC Development
            </div>
            <div className="text-center pt-3 pb-xl-5 pb-3 max-w-900px mx-auto pb-xl-5 pb-3">
              Our developers have experience and expertise in a wide range of
              development technologies. They choose the ideal tech stack based
              on the business needs and requirements with a motive to provide
              the best outcome at an optimal cost.{' '}
            </div>
            <div className="min-h-lg-450px min-h-350px d-flex flex-wrap justify-content-center">
              <div className="toolBox">
                <Image
                  src="/assets/images/solutions/dotnet-mvc-img/tools/1.png"
                  alt="development"
                  className="mb-2"
                  quality={70}
                  height={45}
                  width={45}
                />
                <div>Microsoft Web Platform Installer</div>
              </div>
              <div className="toolBox">
                <Image
                  src="/assets/images/solutions/dotnet-mvc-img/tools/2.png"
                  alt="development"
                  className="mb-2"
                  quality={70}
                  height={45}
                  width={45}
                />
                <div>NuGet</div>
              </div>
              <div className="toolBox">
                <Image
                  src="/assets/images/solutions/dotnet-mvc-img/tools/3.png"
                  alt="development"
                  className="mb-2"
                  quality={70}
                  height={45}
                  width={45}
                />
                <div>Visual Studio Gallery</div>
              </div>
              <div className="toolBox">
                <Image
                  src="/assets/images/solutions/dotnet-mvc-img/tools/4.png"
                  alt="development"
                  className="mb-2"
                  quality={70}
                  height={45}
                  width={45}
                />
                <div>ReShaper</div>
              </div>
              <div className="toolBox">
                <Image
                  src="/assets/images/solutions/dotnet-mvc-img/tools/5.png"
                  alt="development"
                  className="mb-2"
                  quality={70}
                  height={45}
                  width={45}
                />
                <div>Web Essentials for Visual Studio</div>
              </div>
            </div>
            <div className="text-center">
              <Image
                src="/assets/images/solutions/dotnet-mvc-img/dotnetLogo.svg"
                alt="development"
                className="dotLogo"
                quality={70}
                height={89}
                width={223}
              />
            </div>
            <svg
              className="Circle"
              width="1004"
              height="1004"
              viewBox="0 0 1004 1004"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <circle
                cx="502"
                cy="502"
                r="502"
                fill="url(#paint0_radial_513_305)"
              />
              <circle
                cx="502"
                cy="502"
                r="390"
                fill="url(#paint1_radial_513_305)"
              />
              <circle
                cx="502"
                cy="502"
                r="291"
                fill="url(#paint2_radial_513_305)"
              />
              <defs>
                <radialGradient
                  id="paint0_radial_513_305"
                  cx="0"
                  cy="0"
                  r="1"
                  gradientUnits="userSpaceOnUse"
                  gradientTransform="translate(502 502) rotate(90) scale(502)"
                >
                  <stop offset="0.739583" stopColor="#F2F6FF" stopOpacity="0" />
                  <stop offset="1" stopColor="#E9EFFA" />
                </radialGradient>
                <radialGradient
                  id="paint1_radial_513_305"
                  cx="0"
                  cy="0"
                  r="1"
                  gradientUnits="userSpaceOnUse"
                  gradientTransform="translate(502 502) rotate(90) scale(390)"
                >
                  <stop offset="0.739583" stopColor="#F2F6FF" stopOpacity="0" />
                  <stop offset="1" stopColor="#E9EFFA" />
                </radialGradient>
                <radialGradient
                  id="paint2_radial_513_305"
                  cx="0"
                  cy="0"
                  r="1"
                  gradientUnits="userSpaceOnUse"
                  gradientTransform="translate(502 502) rotate(90) scale(291)"
                >
                  <stop offset="0.739583" stopColor="#F2F6FF" stopOpacity="0" />
                  <stop offset="1" stopColor="#E9EFFA" />
                </radialGradient>
              </defs>
            </svg>
          </div>
        </div>

        <div className="container mb-100px secHireMain" id="secHireMain">
          <div className="img1">
            <img
              src={`${CDN_URL}/assets/images/solutions/dotnet-mvc-img/h1.jpg`}
              alt=""
            />
          </div>
          <div className="img2">
            <img
              src={`${CDN_URL}/assets/images/solutions/dotnet-mvc-img/h2.jpg`}
              alt=""
            />
          </div>
          <div className="img3">
            <img
              src={`${CDN_URL}/assets/images/solutions/dotnet-mvc-img/h3.jpg`}
              alt=""
            />
          </div>
          <div className="img4">
            <img
              src={`${CDN_URL}/assets/images/solutions/dotnet-mvc-img/h4.jpg`}
              alt=""
            />
          </div>
          <div className="row justify-content-center">
            <div className="col-xl-9">
              <div className="secHire" id="secHire">
                <div className="zIndex1">
                  <div className="title36px700 head_color text-center titleBorder left50">
                    Hire ASP.Net MVC Developers from WebClues
                  </div>
                  <div className="text-center pt-3 pb-xl-5 pb-3 max-w-700px mx-auto pb-xl-5 pb-3">
                    We house a team of highly skilled ASP.Net developers with an
                    extensive amount of understanding of the MVC architecture.
                    Working with the best ASP.Net application development
                    company means you will get the best possible outcome that is
                    way more than the money&apos;s worth.
                  </div>
                  <div className="max-w-700px mx-auto d-flex flex-wrap justify-content-center">
                    <div className="row">
                      <div className="col-md-6 text-center mb-4">
                        <Image
                          src="/assets/images/solutions/dotnet-mvc-img/icon1.svg"
                          alt="development"
                          height={78}
                          width={78}
                        />
                        <div className="fs-xxl-28px fs-xl-24px fs-20px fw-600 head_color">
                          Creative Intelligence
                        </div>
                        <div>
                          We build creative and innovative solutions to help
                          your business thrive in a competitive market.{' '}
                        </div>
                      </div>
                      <div className="col-md-6 text-center mb-4">
                        <Image
                          src="/assets/images/solutions/dotnet-mvc-img/icon2.svg"
                          alt="development"
                          height={78}
                          width={78}
                        />
                        <div className="fs-xxl-28px fs-xl-24px fs-20px fw-600 head_color">
                          Agile Development
                        </div>
                        <div>
                          WebClues is the leading ASP.Net MVC development
                          company because of our agile work methodologies.
                        </div>
                      </div>
                      <div className="col-md-6 text-center mb-4">
                        <Image
                          src="/assets/images/solutions/dotnet-mvc-img/icon3.svg"
                          alt="development"
                          height={78}
                          width={78}
                        />
                        <div className="fs-xxl-28px fs-xl-24px fs-20px fw-600 head_color">
                          Dedicated Developers
                        </div>
                        <div>
                          If requested, we can allocate dedicated developers to
                          work on your project for eight hours every day and get
                          faster results.
                        </div>
                      </div>
                      <div className="col-md-6 text-center mb-4">
                        <Image
                          src="/assets/images/solutions/dotnet-mvc-img/icon4.svg"
                          alt="development"
                          height={78}
                          width={78}
                        />
                        <div className="fs-xxl-28px fs-xl-24px fs-20px fw-600 head_color">
                          Integrity in Work
                        </div>
                        <div>
                          Our transparent work system ensures that your project
                          information is always kept confidential and you have
                          access to the source code at all times.
                        </div>
                      </div>
                    </div>
                    <div className="text-center">
                      <Button className="mx-auto" onClick={handleShowContact}>
                        Consult Our Experts
                      </Button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="container pb-100px secHWW">
          <div className="title36px700 head_color text-center titleBorder left50">
            Our Development Process
          </div>
          <div className="text-center pt-3 pb-xl-5 pb-3 max-w-700px mx-auto pb-xl-5 pb-3">
            Because we follow agile development methodologies you can trust our
            developers to ideate, design, and develop the most suitable solution
            representing the highest quality of web applications in the
            industry.
          </div>
          <div className="row justify-content-center mt-xl-5 mt-3">
            <div className="col-md-6 col-lg-4 col-xl-3 offset-xl-1 pe-xl-4">
              <div className="hwwBox mb-md-5">
                <div className="mb-2 fs-xxl-28px fs-xl-24px fs-20px fw-600 head_color d-flex">
                  <span className="number">1</span>Ideation and Discussion
                </div>
                <div>
                  Our development process starts with understanding your
                  requirements, brainstorming ideas, and holding discussions to
                  create a rough blueprint.
                </div>
              </div>
              <div className="d-none d-md-flex justify-content-lg-end">
                <div className="hwwBox">
                  <div className="mb-2 fs-xxl-28px fs-xl-24px fs-20px fw-600 head_color">
                    <span className="number">3</span>Development
                  </div>
                  <div>
                    As the best ASP.Net development company, we have set new
                    standards in the coding part of building an app. We provide
                    source code authorization with effective coding based on the
                    MVC pattern.
                  </div>
                </div>
              </div>

              <div className="hwwBox d-block d-md-none">
                <div className="mb-2 fs-xxl-28px fs-xl-24px fs-20px fw-600 head_color d-flex">
                  <span className="number">2</span>Design and Wireframing
                </div>
                <div>
                  We have in-house designers who will create the most efficient
                  and smart web app design while taking care of the specific
                  needs of your target audience.
                </div>
              </div>
            </div>
            <div className="col-md-6 col-lg-4 d-none d-lg-block">
              <div className="position-relative">
                <div className="logo">
                  <Image
                    src="/assets/images/solutions/dotnet-mvc-img/logo.svg"
                    alt="development"
                    width={150}
                    height={141}
                  />
                </div>

                <div className="line1">
                  <Image
                    src="/assets/images/solutions/dotnet-mvc-img/line1.svg"
                    alt="development"
                    className=""
                    width={130}
                    height={73}
                  />
                </div>
                <div className="line2">
                  <Image
                    src="/assets/images/solutions/dotnet-mvc-img/line2.svg"
                    alt="development"
                    className=""
                    width={100}
                    height={60}
                  />
                </div>
                <div className="line3">
                  <Image
                    src="/assets/images/solutions/dotnet-mvc-img/line3.svg"
                    alt="development"
                    className=""
                    width={130}
                    height={46}
                  />
                </div>
                <div className="line4">
                  <Image
                    src="/assets/images/solutions/dotnet-mvc-img/line4.svg"
                    alt="development"
                    className=""
                    width={180}
                    height={54}
                  />
                </div>
                <div className="w-100 text-center middle_img">
                  <Image
                    src="/assets/images/solutions/dotnet-mvc-img/wave.svg"
                    alt="development"
                    className=""
                    width={296}
                    height={296}
                  />
                </div>
              </div>
            </div>
            <div className="col-md-6 col-lg-4 col-xl-3">
              <div className="hwwBox d-none d-md-block mb-5 mt-3">
                <div className="mb-2 fs-xxl-28px fs-xl-24px fs-20px fw-600 head_color d-flex">
                  <span className="number">2</span>Design and Wireframing
                </div>
                <div>
                  We have in-house designers who will create the most efficient
                  and smart web app design while taking care of the specific
                  needs of your target audience.
                </div>
              </div>
              <div className="hwwBox d-block d-md-none mb-100px">
                <div className="mb-2 fs-xxl-28px fs-xl-24px fs-20px fw-600 head_color">
                  <span className="number">3</span>Development
                </div>
                <div>
                  As the best ASP.Net development company, we have set new
                  standards in the coding part of building an app. We provide
                  source code authorization with effective coding based on the
                  MVC pattern.
                </div>
              </div>
              <div className="d-flex justify-content-lg-end">
                <div className="hwwBox ">
                  <div className="mb-2 fs-xxl-28px fs-xl-24px fs-20px fw-600 head_color">
                    <span className="number">4</span>Debugging
                  </div>
                  <div>
                    We ensure that every solution is bug-free and performs as
                    intended. Our testing teams and quality assurance engineers
                    follow the latest coding standards while checking for errors
                    and issues.
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="pb-100px secWork">
          <div className="container">
            <div className="d-block d-lg-none">
              <div className="title36px700 head_color text-center titleBorder left50">
                Glimpses of Our Awesome Works in ASP.Net MVC Development
              </div>
              <div className="text-center pt-3 pb-xl-5 pb-3 pb-xl-5 pb-3">
                We come from years of experience and a proven track record in
                ASP.Net application development services. Every project we
                onboard is delivered with high-quality results and unmatched
                efficiency.{' '}
              </div>
            </div>
            <div className="row">
              <div className="col-lg-4 col-md-6">
                <div className="workImg">
                  <Image
                    src="/assets/images/solutions/dotnet-mvc-img/w1.jpg"
                    alt="development"
                    className=""
                    width={296}
                    height={330}
                  />

                  <div className="fs-xl-23px fs-18px fw-600 head_color pt-3">
                    Dimendscaasi
                  </div>
                  <div>
                    Dimendscaasi Chicago is an eCommerce website for
                    Jewellery&apos;s. Diamonds are imported from different 3rd
                    party vendors on daily bassis and are used to make Custom
                    Made Jewellery.
                  </div>
                </div>
                <div className="workImg">
                  <Image
                    src="/assets/images/solutions/dotnet-mvc-img/w2.jpg"
                    alt="development"
                    className=""
                    width={296}
                    height={330}
                  />
                  <div className="fs-xl-23px fs-18px fw-600 head_color pt-3">
                    Skyloov
                  </div>
                  <div>
                    Welcome to the world&apos;s first dynamic 360 Real Estate
                    Portal. We are putting the city in the palm of your hand in
                    real 360 degree view.
                  </div>
                </div>
              </div>
              <div className="d-none d-lg-block col-lg-4 col-md-6">
                <div className="secTitle d-none d-lg-block stickyTop">
                  <div className="title36px700 head_color text-center titleBorder left50">
                    Glimpses of Our Awesome Works in ASP.Net MVC Development
                  </div>
                  <div className="text-center pt-3 pb-xl-5 pb-3  pb-xl-5 pb-3">
                    We come from years of experience and a proven track record
                    in ASP.Net application development services. Every project
                    we onboard is delivered with high-quality results and
                    unmatched efficiency.
                  </div>
                </div>
              </div>
              <div className="col-lg-4 col-md-6">
                <div className="workImg">
                  <Image
                    src="/assets/images/solutions/dotnet-mvc-img/w3.jpg"
                    alt="development"
                    className=""
                    width={296}
                    height={330}
                  />
                  <div className="fs-xl-23px fs-18px fw-600 head_color pt-3">
                    Bravatech
                  </div>
                  <div>
                    At Bravatech, we are a team of connectors, facilitators and
                    enablers. We connect customers with specific IT
                    professionals.
                  </div>
                </div>
                <div className="workImg">
                  <Image
                    src="/assets/images/solutions/dotnet-mvc-img/w4.jpg"
                    alt="development"
                    className=""
                    width={296}
                    height={330}
                  />
                  <div className="fs-xl-23px fs-18px fw-600 head_color pt-3">
                    MyOrde
                  </div>
                  <div>
                    A handy personalized waiter app for everyone which fits all
                    dining experiences regardless of menu.
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="mb-100px secServe">
          <div className="container">
            <div className="title36px700  text-center titleBorder left50 text-white">
              Industries We Have Worked For
            </div>
            <div className="text-center pt-3 pb-xl-5 pb-3 pb-xl-5 pb-3 text-white opacity-60">
              WebClues has the industry-specific knowledge to build performant
              applications pertaining to every use case.
            </div>
            <div className="row">
              <div className="mb-4 col-lg-3 col-md-6">
                <div className="serveBox">
                  <svg
                    className="rvt-icon rat-icon-healthcare text-orange"
                    width="36"
                    height="37"
                    viewBox="0 0 36 37"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M15.671 0.799999C16.5361 0.276047 17.5282 -0.000961304 18.5395 -0.000961304C19.5509 -0.000961304 20.543 0.276047 21.408 0.799999L23.445 2.046C26.303 3.793 29.558 4.182 32.828 4.574C33.885 4.701 34.943 4.827 35.99 5C35.99 5 36.013 6.834 35.989 7.666L35.78 14.817C35.6 20.95 32.873 26.765 28.195 30.991C25.988 32.984 23.705 34.785 21.082 36.281C20.3091 36.7183 19.4423 36.9636 18.5548 36.9961C17.6673 37.0286 16.785 36.8475 15.982 36.468C12.953 35.028 10.271 33.202 7.82203 30.991C3.14403 26.765 0.417032 20.95 0.238032 14.817L0.030032 7.689C0.00503201 6.844 0.030032 5 0.030032 5C0.880032 4.9 1.74603 4.817 2.61903 4.734C6.47203 4.368 10.453 3.99 13.719 1.994L15.672 0.799999H15.671ZM16 16V9H20V16H27V20H20V27H16V20H9.00003V16H16Z"
                      fill="currentColor"
                    />
                  </svg>
                  <div className="text-white fs-xxl-28px fs-xl-24px fs-20px fw-600 pt-3 pb-2">
                    Healthcare
                  </div>
                  <div className="text-white opacity-60">
                    High-performance healthcare applications built on the MVC
                    architecture for better security and scalable
                    implementation.{' '}
                  </div>
                </div>
              </div>
              <div className="mb-4 col-lg-3 col-md-6">
                <div className="serveBox">
                  <svg
                    className="rvt-icon rat-icon-sports text-orange"
                    width="48"
                    height="47"
                    viewBox="0 0 48 47"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M0.80171 32.7008C0.595044 38.8517 1.62838 43.7317 2.53254 44.6213C3.43671 45.5108 8.42254 46.5529 14.6484 46.3242L0.80171 32.7008ZM26.79 1.33667C20.7709 2.40417 14.4159 4.7425 9.68838 9.41917C4.96088 14.0958 2.55838 20.3229 1.47338 26.245L21.1842 45.6379C27.2292 44.5958 33.5584 42.2321 38.2859 37.5554C43.0134 32.8788 45.4159 26.6517 46.5009 20.7296L26.79 1.33667ZM31.2334 19.9417L20.3834 30.6167C19.3759 31.6079 17.7742 31.6079 16.7667 30.6167C15.7592 29.6254 15.7592 28.0496 16.7667 27.0583L27.6167 16.3833C28.6242 15.3921 30.2259 15.3921 31.2334 16.3833C32.2409 17.3746 32.2409 18.9504 31.2334 19.9417ZM47.1984 14.2992C47.405 8.14834 46.3717 3.26834 45.4675 2.37875C44.5634 1.48917 39.5775 0.447086 33.3517 0.675836L47.1984 14.2992Z"
                      fill="currentColor"
                    />
                  </svg>
                  <div className="text-white fs-xxl-28px fs-xl-24px fs-20px fw-600 pt-3 pb-2">
                    Sports
                  </div>
                  <div className="text-white opacity-60">
                    We build solutions for the sports industry according to the
                    niche requirements and customer base helping businesses
                    flourish.
                  </div>
                </div>
              </div>
              <div className="mb-4 col-lg-3 col-md-6">
                <div className="serveBox">
                  <svg
                    className="rvt-icon rat-icon-automotive text-orange"
                    width="49"
                    height="39"
                    viewBox="0 0 49 39"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M1.74396 13.5285H7.72651L12.7031 0H36.2888L41.2678 13.5285H47.2504C48.2119 13.5285 49 14.3167 49 15.2782V29.6799C49 30.6415 48.2143 31.4296 47.2504 31.4296H42.5442V37.3131C42.5442 37.742 42.1946 38.0912 41.7662 38.0912H35.6942C35.2654 38.0912 34.9162 37.7416 34.9162 37.3131V31.4296H14.0838V37.3131C14.0838 37.742 13.7342 38.0912 13.3058 38.0912H7.23385C6.80502 38.0912 6.45581 37.7416 6.45581 37.3131V31.4296H1.74965C0.78812 31.4296 0 30.6415 0 29.6799V15.2782C0 14.3166 0.78572 13.5285 1.74965 13.5285H1.74396ZM11.3674 13.5285H37.6246L33.7558 4.11608H15.2359L11.3674 13.5285ZM41.0742 21.1565C42.9379 21.1565 44.4495 22.6681 44.4495 24.5318C44.4495 26.3954 42.9379 27.9046 41.0742 27.9046C39.2105 27.9046 37.7013 26.3954 37.7013 24.5318C37.7013 22.6681 39.2105 21.1565 41.0742 21.1565ZM7.91669 21.1565C9.78036 21.1565 11.2919 22.6681 11.2919 24.5318C11.2919 26.3954 9.78274 27.9046 7.91669 27.9046C6.05301 27.9046 4.54382 26.3954 4.54382 24.5318C4.54382 22.6681 6.05301 21.1565 7.91669 21.1565ZM18.3308 23.3819H30.6632C30.9235 23.3819 31.1365 23.5949 31.1365 23.8552V27.7583C31.1365 28.0186 30.9235 28.2316 30.6632 28.2316H18.3308C18.0705 28.2316 17.8575 28.0186 17.8575 27.7583V23.8552C17.8575 23.5949 18.0705 23.3819 18.3308 23.3819Z"
                      fill="currentColor"
                    />
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M1.74396 13.5285H7.72651L12.7031 0H36.2888L41.2678 13.5285H47.2504C48.2119 13.5285 49 14.3167 49 15.2782V29.6799C49 30.6415 48.2143 31.4296 47.2504 31.4296H42.5442V37.3131C42.5442 37.742 42.1946 38.0912 41.7662 38.0912H35.6942C35.2654 38.0912 34.9162 37.7416 34.9162 37.3131V31.4296H14.0838V37.3131C14.0838 37.742 13.7342 38.0912 13.3058 38.0912H7.23385C6.80502 38.0912 6.45581 37.7416 6.45581 37.3131V31.4296H1.74965C0.78812 31.4296 0 30.6415 0 29.6799V15.2782C0 14.3166 0.78572 13.5285 1.74965 13.5285H1.74396ZM11.3674 13.5285H37.6246L33.7558 4.11608H15.2359L11.3674 13.5285ZM41.0742 21.1565C42.9379 21.1565 44.4495 22.6681 44.4495 24.5318C44.4495 26.3954 42.9379 27.9046 41.0742 27.9046C39.2105 27.9046 37.7013 26.3954 37.7013 24.5318C37.7013 22.6681 39.2105 21.1565 41.0742 21.1565ZM7.91669 21.1565C9.78036 21.1565 11.2919 22.6681 11.2919 24.5318C11.2919 26.3954 9.78274 27.9046 7.91669 27.9046C6.05301 27.9046 4.54382 26.3954 4.54382 24.5318C4.54382 22.6681 6.05301 21.1565 7.91669 21.1565ZM18.3308 23.3819H30.6632C30.9235 23.3819 31.1365 23.5949 31.1365 23.8552V27.7583C31.1365 28.0186 30.9235 28.2316 30.6632 28.2316H18.3308C18.0705 28.2316 17.8575 28.0186 17.8575 27.7583V23.8552C17.8575 23.5949 18.0705 23.3819 18.3308 23.3819Z"
                      fill="currentColor"
                    />
                  </svg>
                  <div className="text-white fs-xxl-28px fs-xl-24px fs-20px fw-600 pt-3 pb-2">
                    Automotive
                  </div>
                  <div className="text-white opacity-60">
                    For the automotive industry, we take care of the segmented
                    market and create bespoke designs with customised pages and
                    UI.
                  </div>
                </div>
              </div>
              <div className="mb-4 col-lg-3 col-md-6">
                <div className="serveBox">
                  <svg
                    className="rvt-icon rat-icon-ecommerce text-orange"
                    width="40"
                    height="39"
                    viewBox="0 0 40 39"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M35.3199 13.4548C35.1249 12.4797 34.3448 11.6997 33.3698 11.6997H29.275V9.74961C29.275 4.28961 24.985 0 19.5254 0C14.0651 0 9.77498 4.29003 9.77498 9.74961V11.6997H5.67988C4.70483 11.6997 3.92505 12.4798 3.72979 13.4548L0.0249565 36.855C-0.169986 38.025 0.805048 39 1.97504 39H37.075C38.2449 39 39.22 38.025 39.025 36.855L35.3199 13.4548ZM13.6746 9.74961C13.6746 6.43463 16.2094 3.89943 19.5247 3.89943C22.8397 3.89943 25.3749 6.4343 25.3749 9.74961V11.6997H13.6744L13.6746 9.74961ZM28.6897 20.8646L16.99 32.5643C16.21 33.3444 15.04 33.3444 14.2599 32.5643L8.40975 26.7141C7.62966 25.934 7.62966 24.764 8.40975 23.984C9.18984 23.2039 10.3598 23.2039 11.1399 23.984L15.6252 28.4693L25.9603 18.1342C26.7404 17.3541 27.9104 17.3541 28.6904 18.1342C29.4702 18.9142 29.4702 20.0842 28.6901 20.8643L28.6897 20.8646Z"
                      fill="currentColor"
                    />
                  </svg>
                  <div className="text-white fs-xxl-28px fs-xl-24px fs-20px fw-600 pt-3 pb-2">
                    eCommerce
                  </div>
                  <div className="text-white opacity-60">
                    Build extendable and adaptable solutions based on the MVC
                    structure to create highly functional online eCommerce
                    platforms.
                  </div>
                </div>
              </div>
              <div className="mb-4 col-lg-3 col-md-6">
                <div className="serveBox">
                  <svg
                    className="rvt-icon rat-icon-financefintech text-orange"
                    width="53"
                    height="40"
                    viewBox="0 0 53 40"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M2.58731 38.3257C8.06225 39.5425 20.9126 41.6712 28.822 37.7173C35.5895 34.3718 43.8022 35.4362 48.5924 36.5764C50.6452 37.0324 52.6229 35.512 52.6229 33.3826L52.6216 4.63991C52.6216 3.19545 51.6331 1.90211 50.1881 1.52206C45.8541 0.305281 36.4246 -1.51921 28.8201 2.28223C21.52 5.93187 9.8863 4.33506 3.87796 3.19482C1.82514 2.81473 0 4.33571 0 6.38862V35.1313C0.000627166 36.7282 1.06562 38.0209 2.58654 38.3251L2.58731 38.3257ZM26.3108 6.31228C33.8385 6.31228 39.9983 12.4714 39.9983 19.9998C39.9983 27.5276 33.8392 33.6873 26.3108 33.6873C18.783 33.6873 12.6233 27.5282 12.6233 19.9998C12.6239 12.4714 18.783 6.31228 26.3108 6.31228Z"
                      fill="currentColor"
                    />
                    <path
                      d="M23.1172 20.4564C24.1056 20.9889 25.17 21.2166 26.311 21.2166C26.7669 21.2166 27.1476 21.2925 27.4519 21.5967C27.9843 22.0527 27.9078 22.7376 27.376 23.1177C26.4634 23.8779 25.0948 23.4978 24.6382 22.3575H20.6077C20.6077 23.1942 20.9119 23.8785 21.3678 24.4869C22.0521 25.3236 22.8888 25.8555 23.8773 26.1597C24.1815 26.2356 24.2574 26.388 24.2574 26.6922V28.5933H28.3637V26.4639C28.3637 26.2356 28.4396 26.1597 28.6679 26.0838C29.3522 25.8555 29.9606 25.4754 30.569 25.0194C31.2532 24.411 31.7857 23.6509 31.8616 22.7383C32.0899 21.2938 31.4816 20.1528 30.3407 19.3163C29.1998 18.4037 27.8312 18.0236 26.3868 18.0236C25.8543 18.0236 25.3983 17.9477 25.0182 17.5677C24.714 17.1876 24.6381 16.731 24.9423 16.3509C25.5507 15.5142 27.1475 15.5907 27.6801 16.4268C27.756 16.5027 27.8319 16.5786 27.8319 16.731C27.8319 16.9593 27.9837 16.9593 28.1361 16.9593H31.634H31.9382C31.9382 15.9708 31.5581 15.2106 30.9497 14.6022C30.3413 13.9179 29.5052 13.4613 28.6685 13.1577C28.5168 13.0818 28.4402 13.0059 28.4402 12.8535V11.3326H24.334V12.7011C24.334 12.9294 24.2581 13.0053 24.0298 13.0812C23.4214 13.3854 22.813 13.6137 22.281 13.9938C20.9125 14.9823 20.38 16.4273 20.7601 17.9477C21.1402 19.1638 22.0527 19.9241 23.1172 20.4565V20.4564Z"
                      fill="currentColor"
                    />
                  </svg>
                  <div className="text-white fs-xxl-28px fs-xl-24px fs-20px fw-600 pt-3 pb-2">
                    Finance &amp; Fintech
                  </div>
                  <div className="text-white opacity-60">
                    With multi-tier architectures, our Fintech applications are
                    scalable and work on the principles of multithreading,
                    caching, and data analytics.{' '}
                  </div>
                </div>
              </div>
              <div className="mb-4 col-lg-3 col-md-6">
                <div className="serveBox">
                  <svg
                    className="rvt-icon rat-icon-education text-orange"
                    width="73"
                    height="43"
                    viewBox="0 0 73 43"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M36.5597 28.1262C34.5386 28.1262 32.5169 27.8267 30.5704 27.3024L13.801 22.2865V33.7407C13.801 35.8371 15.1484 37.6334 17.1701 38.2324L24.5067 40.4035C32.5923 42.7994 41.1275 42.7994 49.2118 40.4035L56.5484 38.2324C58.5695 37.6334 59.9175 35.8365 59.9175 33.7407V22.1371L42.549 27.3032C40.6027 27.9022 38.5814 28.1264 36.5597 28.1264V28.1262Z"
                      fill="currentColor"
                    />
                    <path
                      d="M70.6234 9.56096L41.0524 0.801605C38.1328 -0.0968729 34.9885 -0.0968729 31.9935 0.801605L2.49689 9.56096C0.475808 10.16 0.475808 13.0796 2.49689 13.6785L32.0678 22.4373C34.9874 23.3357 38.1317 23.3357 41.1267 22.4373L66.431 14.9506V21.6135C65.9068 21.913 65.5325 22.4372 65.5325 23.0356V24.8325C65.5325 25.5062 65.9068 26.1052 66.5057 26.33L64.9335 29.9986C64.7088 30.5229 65.0083 31.0465 65.6072 31.1219L67.2541 31.2713H68.2273L69.8742 31.1219C70.3985 31.0472 70.698 30.5229 70.5479 29.9986L68.9758 26.33C69.5748 26.0305 69.949 25.5063 69.949 24.8325V23.0356C69.949 22.4366 69.5747 21.9124 69.0505 21.6135V14.2021L70.6974 13.6778C72.6443 13.0048 72.6443 10.1599 70.6233 9.5609L70.6234 9.56096Z"
                      fill="currentColor"
                    />
                  </svg>
                  <div className="text-white fs-xxl-28px fs-xl-24px fs-20px fw-600 pt-3 pb-2">
                    Education
                  </div>
                  <div className="text-white opacity-60">
                    We configure and engineer multi-platform applications for
                    the education industry helping institutions and businesses
                    grow.
                  </div>
                </div>
              </div>
              <div className="mb-4 col-lg-3 col-md-6">
                <div className="serveBox">
                  <svg
                    className="rvt-icon rat-icon-traveltourism text-orange"
                    xmlns="http://www.w3.org/2000/svg"
                    width="47"
                    height="46"
                    viewBox="0 0 47 46"
                  >
                    <path
                      id="travel"
                      d="M2.164,23.892a20.327,20.327,0,0,1,2.617-13.8A20.755,20.755,0,0,1,15.763,1.175a21.067,21.067,0,0,1,14.22.124,20.746,20.746,0,0,1,10.82,9.11,7.686,7.686,0,0,0-2.652,1.662l-2.609,2.538-7.567-1.614a7.136,7.136,0,0,0-3.544.147,7,7,0,0,0-2.6,1.42l-1.765,1.534a4.82,4.82,0,0,0,.4,7.608,6.912,6.912,0,0,0-1.108.79l-.815.71a4.8,4.8,0,0,0-1.136,5.847l-7.294,5.866A20.43,20.43,0,0,1,2.165,23.893ZM6.115,45.311a8.945,8.945,0,0,0,1.175.374l.158.038c.149.038.293.071.422.095l.168.028c.144.028.293.052.422.066a10.054,10.054,0,0,0,2.46.023l.422-.062h0A9.912,9.912,0,0,0,15.5,44.18l8.714-6.5-.988-2.557-2.609-1.4-8.095,6.515a4.938,4.938,0,0,1-2.244.947A5.268,5.268,0,0,1,9,41.225H8.7l-.2-.038-.125-.024h0a4.325,4.325,0,0,1-.614-.171,5.028,5.028,0,0,1-3.276-3.6,24.5,24.5,0,0,1-3.6-4.919,8.93,8.93,0,0,0-.417,1.079A9.374,9.374,0,0,0,2.2,42.518,9.68,9.68,0,0,0,6.11,45.311Zm40-30.153a3.517,3.517,0,0,0-5.069-.18l-4.2,4.076-9.744-2.083a2.942,2.942,0,0,0-2.537.653L22.8,19.159h0a.775.775,0,0,0,.129,1.264l7.879,4.493-2.7,2.623-3.721-.63h0a2.768,2.768,0,0,0-2.288.639l-.82.715h0a.776.776,0,0,0,.149,1.278l5.1,2.694,2.062,5.336h0a.788.788,0,0,0,.551.482.8.8,0,0,0,.715-.174l.825-.71a2.692,2.692,0,0,0,.93-2.159l-.168-3.788,2.935-2.282,3.5,8.266a.8.8,0,0,0,1.252.284l1.765-1.534h0a2.859,2.859,0,0,0,.959-2.4l-.863-9.8,4.666-3.589a3.417,3.417,0,0,0,.479-4.99Z"
                      fill="currentColor"
                    />
                  </svg>
                  <div className="text-white fs-xxl-28px fs-xl-24px fs-20px fw-600 pt-3 pb-2">
                    Travel &amp; Tourism
                  </div>
                  <div className="text-white opacity-60">
                    Building data-intensive web applications for the tourism
                    industry depending on your requirements, customer base, and
                    services.
                  </div>
                </div>
              </div>
              <div className="mb-4 col-lg-3 col-md-6">
                <div className="serveBox">
                  <svg
                    className="rvt-icon rat-icon-hospitality text-orange"
                    width="46"
                    height="46"
                    viewBox="0 0 46 46"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M34.5858 0.427686C33.1042 1.17604 32.2449 3.06109 33.0285 3.84442C33.6375 4.45307 34.3365 4.17802 34.5921 3.22893C35.003 1.7039 36.4182 1.55126 36.8793 2.98202C37.0078 3.38062 37.1978 3.81363 37.3016 3.94421C37.561 4.27097 38.2972 4.24283 38.5858 3.89517C38.9136 3.50037 38.7203 1.98636 38.2615 1.35643C37.8515 0.793215 36.4281 0 35.8274 0C35.6103 0 35.0516 0.192554 34.5858 0.427686ZM9.37746 4.54545C5.76264 5.86671 3.82412 9.43722 4.62843 13.293C5.1268 15.6826 6.49869 17.4399 8.67298 18.4738C10.1835 19.1921 11.5248 19.3329 13.0742 18.936C15.3835 18.3447 16.8608 17.101 17.9277 14.8498C18.4751 13.6949 18.5238 13.4339 18.5177 11.6901C18.5093 9.33249 18.0897 8.15131 16.7107 6.6048C14.8222 4.48671 11.8341 3.6475 9.37746 4.54545ZM33.8309 5.47704C30.2319 6.41757 27.6942 9.4319 27.2582 13.2847C27.026 15.3362 26.4465 15.2066 35.8525 15.2066H43.8998L44.1814 14.7768C44.409 14.4296 44.4288 14.1038 44.2839 13.0809C43.7154 9.06789 40.9605 6.02505 37.2611 5.32384C35.908 5.06722 35.2946 5.0946 33.8309 5.47704ZM25.8873 17.5935C25.3741 17.9527 25.3446 18.4606 25.8124 18.8838C26.1263 19.1677 27.1004 19.1983 35.852 19.1983C43.1366 19.1983 45.6004 19.1417 45.7719 18.9702C46.1334 18.6089 46.0492 17.7172 45.6324 17.4943C45.393 17.3661 41.9565 17.2975 35.7871 17.2975C27.5172 17.2975 26.256 17.3352 25.8873 17.5935ZM34.5721 20.5806C34.1772 20.8447 32.8907 22.5052 31.264 24.8506C29.7999 26.9615 28.5111 28.7783 28.4002 28.8878C28.2587 29.0273 26.7956 27.9537 23.5158 25.3044C17.4951 20.4407 17.6358 20.5002 11.9206 20.3852C7.63765 20.2989 6.62323 20.4211 5.04389 21.2142C2.88957 22.2959 1.32925 24.1506 0.514479 26.5979C0.116318 27.7945 0.0957821 28.2102 0.0282811 36.4607C-0.0342762 44.1035 -0.00803669 45.1264 0.261207 45.5371L0.564487 46H11.5653C20.5085 46 22.6052 45.9525 22.7765 45.7462C22.9186 45.5752 23.0037 43.5316 23.0376 39.4859L23.0878 33.4794L24.704 34.8155C27.2192 36.8949 27.8517 37.2564 28.972 37.2554C30.1956 37.2547 30.9198 36.8196 31.8787 35.5097C33.9891 32.6264 39.0184 25.184 39.1913 24.6883C39.5185 23.7501 39.2918 22.1699 38.7233 21.4248C37.7408 20.137 35.82 19.7464 34.5721 20.5806Z"
                      fill="currentColor"
                    />
                  </svg>
                  <div className="text-white fs-xxl-28px fs-xl-24px fs-20px fw-600 pt-3 pb-2">
                    Hospitality
                  </div>
                  <div className="text-white opacity-60">
                    {' '}
                    We build performant applications for the hospitality
                    industry for your customers and management activities.
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="container pb-100px">
          <div className="title36px700 head_color text-center titleBorder left50">
            What Our Customers are Saying?
          </div>
          <div className="text-center pt-3 pb-xl-5 pb-3 pb-xl-5 pb-3">
            WebClues has provided the desired results for every client. Here are
            a few good words shared by our clients.
          </div>
          <div className="row customerSlider">
            <div className="col-md-4 mb-3">
              <div className="customerBox h-100">
                <Image
                  src="/assets/images/solutions/dotnet-mvc-img/michael_houlder.jpg"
                  alt="development"
                  className=""
                  width={80}
                  height={80}
                />

                <div className="head_color fs-xxl-28px fs-xl-24px fs-20px fw-600 mt-2">
                  Michael
                </div>
                <div className="fs-14px mb-2">CEO, Canada</div>
                <div>
                  We were very pleased with their ability to turn our idea into
                  a reality. They have got aced designers and developers who can
                  boost customer engagement and bring on board new revenue
                  channels.
                </div>
              </div>
            </div>
            <div className="col-md-4 mb-3">
              <div className="customerBox h-100">
                <Image
                  src="/assets/images/solutions/dotnet-mvc-img/Stephen_Belcher.jpg"
                  alt="development"
                  className=""
                  width={80}
                  height={80}
                />
                <div className="head_color fs-xxl-28px fs-xl-24px fs-20px fw-600 mt-2">
                  Michael
                </div>
                <div className="fs-14px mb-2">
                  Director of IT Solutions, Nashville - USA
                </div>
                <div>
                  They always come up with valuable insights. I appreciate their
                  ongoing communication, it impressed me from the start.
                </div>
              </div>
            </div>
            <div className="col-md-4 mb-3">
              <div className="customerBox h-100">
                <Image
                  src="/assets/images/solutions/dotnet-mvc-img/Shaz-Mehr-Khan.jpg"
                  alt="development"
                  className=""
                  width={80}
                  height={80}
                />
                <div className="head_color fs-xxl-28px fs-xl-24px fs-20px fw-600 mt-2">
                  Shaz
                </div>
                <div className="fs-14px mb-2">Founder & CEO, Australia</div>
                <div>
                  I am glad that I choose WebClues as my IT solution provider.
                  They have hardworking and innovative people on board who make
                  things happen.
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="solutions_faq pb-lg-5">
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-md-9 text-center mb-3">
                <h3 className="text_black faq_title">FAQ&apos;s</h3>
                <p>
                  WebClues provides end-to-end ASP.Net MVC development for every
                  industry and vertical. Following are a few general questions
                  and answers you may wish to ask before hiring us for your
                  project.
                </p>
              </div>
              <div className="col-md-9">
                <Accordion defaultActiveKey="0" flush>
                  {faqJsonData.map((faq) => (
                    <Accordion.Item key={faq.id} eventKey={faq.id}>
                      <Accordion.Header>{faq.title}</Accordion.Header>
                      <Accordion.Body>{faq.description}</Accordion.Body>
                    </Accordion.Item>
                  ))}
                </Accordion>
              </div>
            </div>
          </div>
        </div>
      </main>
      <ContactUsAzureModel show={showContact} onClose={handleCloseContact} />
    </PageWrapper>
  )
}

export default HireAspDotnetMvcDevelopers
